import { Component, OnInit, input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-select-check-all',
    template: `
    <mat-checkbox class="mat-option"
                [disableRipple]="true"
                [indeterminate]="isIndeterminate()"
                [checked]="isChecked()"
                (click)="$event.stopPropagation()"
                (change)="toggleSelection($event)">
      {{text()}}
    </mat-checkbox>
  `,
    styles: [''],
    imports: [MatCheckbox]
})
export class SelectCheckAllComponent implements OnInit {
  readonly model = input<NgModel>(undefined);
  readonly values = input<any[]>([]);
  readonly text = input('Select All');

  constructor() { }

  ngOnInit() {
  }

  isChecked(): boolean {
    const model = this.model();
    const values = this.values();
    return model.value && values.length
      && model.value.length === values.length;
  }

  isIndeterminate(): boolean {
    const model = this.model();
    const values = this.values();
    return model.value && values.length && model.value.length
      && model.value.length < values.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.model().update.emit(this.values().map(x => x.value));
    } else {
      this.model().update.emit([]);
    }
  }
}
